import React, { useEffect, useState } from "react";
import {
  ButtonStrip,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  hasValue,
  AlertBar,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { apiServices } from "../../services/apiServices";
import OfflineDb from '../../db'
import moment from "moment";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import CreateField from '../../component/fields/CreateSurveyField'
import _ from "lodash"
import FooterMenu from "../../component/layout/FooterMenu";
const { Form, Field, FormSpy } = ReactFinalForm;

const DatasetManagement = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [years, setYears] = useState([
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
  ]);
  const [yearValue, setYearValue] = React.useState(null);

  const [months, setMonths] = useState([]);
  const [monthValue, setMonthValue] = React.useState(null);

  const [dataSetElementList, setDataSetElementList] = useState([])

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [initialSurveyFilterValue, setInitialSurveyFilterValue] = React.useState(null);
  const [initialSurveyValue, setInitialSurveyValue] = React.useState(null);
  const [progarmData, setProgarmData] = useState(null)
  const [programRules, setProgramRules] = useState(null)
  const [programRulesVariables, setProgramRulesVariables] = useState(null)
  const [datasetRules, setDatasetRules] = useState(null)
  const [sessionUserBoValue,setSessionUserBoValue] = React.useState(null)
  const [activeCaseDetails, setActiveCaseDetails] = useState(null)
  const [surveyFormData, setSurveyFormData] = useState(null);
  const [Configuration, setConfiguration] = React.useState(null);
  const [offlineSurveyEditData, setofflineSurveyEdit] = useState(null);
  const [surveyDataSet, setSurveyDataSet] = useState(null);

  async function getDataFromDatabase() {
    let metadata = await OfflineDb.getDataFromPouchDB('metaData')
    setProgarmData(metadata.data)

    let surveyFormData = await OfflineDb.getDataFromPouchDB("surveyFormData");
    setSurveyFormData(surveyFormData);

    let progRule = await OfflineDb.getDataFromPouchDB('programRules')
    setProgramRules(progRule.data)

    let progRuleVariable = await OfflineDb.getDataFromPouchDB('programRulesVariables')
    setProgramRulesVariables(progRuleVariable.data)

    let datasetRules = await OfflineDb.getDataFromPouchDB('datasetRules')
    setDatasetRules(datasetRules.data)

    let offlineSurveyDetails = await OfflineDb.getDataFromPouchDB('activeCaseDetails')
    setActiveCaseDetails(offlineSurveyDetails)

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let dataSetId = await OfflineDb.getDataFromPouchDB("currentDataSet");
    setSurveyDataSet(dataSetId.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfiguration(configurations.data.configuration);

    let offlineSurveyEdit = await OfflineDb.getDataFromPouchDB(
        "activeCaseFormData"
      );
      setofflineSurveyEdit(offlineSurveyEdit);
  }
  const onChange = () => {
    console.log('onChange')
  }

  function addYear() {
    let currentYear = moment().year();
    if (currentYear != "2021" && currentYear != "2022") {
      currentYear = currentYear.toString();
      years.push({ value: currentYear, label: currentYear });
      setYears(years);
    }
    //console.log("years",currentYear,years);
  }

  const submit = (values) => {
    // console.log('submit', values,surveyDataSet,sessionUserBoValue,sessionUserBoValue.organisationUnits[0])
    // return
    // console.log(yearValue, monthValue)
    let saveObj = {
      "dataSet": surveyDataSet,
      dataValues: [],
    };
    const data = values;
    Object.keys(values).map(function (objectKey, index) {
      const obj = {
        dataElement: objectKey,
        period: yearValue.toString() + monthValue.toString(), //values[weekID],//moment(selectedDate).format('YYYYMMDD'),
        orgUnit: sessionUserBoValue && sessionUserBoValue.organisationUnits && sessionUserBoValue.organisationUnits[0]  ? sessionUserBoValue.organisationUnits[0].id: "fNfswLkiSd4",
        value: values[objectKey],
        categoryOptionCombo: "HllvX50cXC0",
      };
      saveObj.dataValues.push(obj);
    })
    console.log(saveObj)
    if (navigator.onLine) {
      setGlobalSpinner(true);
      apiServices
        .postAPI("dataValueSets.json", saveObj)
        .then((response) => {
          setGlobalSpinner(false);
          console.log("response", response)
          swal({
            title: t("Data submitted successfully"),
            text: "",
            icon: "success",
            button: t("Ok"),
          }).then(userResponse => {
            history.push("layout/home");
          });
        })
    }
  }

  const getDataset = (datasetid) => {
    setDataSetElementList([])
    apiServices.getAPI('dataSets/' + datasetid + '?fields=dataSetElements[id,dataSet[id],dataElement[*,all]').then(res => {
      console.log(res)
      setDataSetElementList(res.data.dataSetElements)
    })
  }
  useEffect(() => {
    //getDataset("ChUwGRH0ppv")
    getDataFromDatabase()
    addYear()
  }, [])
//   useEffect(() => {
//     if(progarmData != null && programRules != null && programRulesVariables != null && datasetRules != null){
//       getDataset("ChUwGRH0ppv")
//     }
//   }, [progarmData,programRules,programRulesVariables,datasetRules])
  useEffect(() => {
    if (yearValue) {
      setMonths([
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
      ]);
    }
  }, [yearValue]);
  useEffect(() => {
    if(yearValue == null || monthValue == null)
    return
    if(sessionUserBoValue != null && surveyDataSet != null){
        let orgUnit = sessionUserBoValue && sessionUserBoValue.organisationUnits && sessionUserBoValue.organisationUnits[0] ? sessionUserBoValue.organisationUnits[0].id : "fNfswLkiSd4"
        apiServices.getAPI('dataValueSets.json?period=' + yearValue.toString() + monthValue.toString() + '&dataSet='+surveyDataSet+'&orgUnit='+orgUnit+'&multiOrganisationUnit=false').then((res) => {
        console.log(res)
        let tempObject = {}
        res.data.dataValues && res.data.dataValues.map(values => {
            tempObject[values.dataElement] = values.value
        })
        setInitialSurveyValue(tempObject)
        }).catch((err) => {

        });
    }
  }, [yearValue, monthValue,surveyDataSet,sessionUserBoValue])

  function onSubmit(values) {
    console.log(values)
  }

  function renderField(registrationFields, values) {
    return (
        <CreateField fieldData={registrationFields} values={values} programRules={programRules} programRulesVariables={programRulesVariables} datasetRules={datasetRules} programData={progarmData} activeCaseDetails={activeCaseDetails}/>
    )
}
  return (
    <>
      <section
        className="surveyform regcustombg customregistrationtabs regcasetabs1 surveyformholder feedbackformholder"
        style={{
          flexGrow: 1,
          padding: 0,
          width: "100%"
        }}
      >
        <FooterMenu></FooterMenu>
        <Form
          onSubmit={onSubmit}
          initialValues={initialSurveyFilterValue}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
          }) => (
            <>
              <form
                className="fullWidth pl-pr-20"
                onSubmit={handleSubmit}
                style={{ padding: "0px 40px" }}
              >
                {values && values["years"] && values["years"] != yearValue
                  ? setYearValue(values["years"])
                  : ""}
                {values && values["month"] && values["month"] != monthValue
                  ? setMonthValue(values["month"])
                  : ""}
                <Grid container className="">
                  <Grid container spacing={0} xs={12} lg={12}>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={3}
                      lg={3}
                      className="yearly-block"
                      id="yearly"
                      style={{ paddingLeft: "5px", paddingRight: "5px" }}
                    >
                      <Field
                        id="years"
                        name="years"
                        label={t("Select Year")}
                        component={SingleSelectFieldFF}
                        key="years"
                        options={years != null ? years : []}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      md={3}
                      lg={3}
                      id="monthly"
                      style={{ paddingLeft: "5px", paddingRight: "5px" }}
                    >
                      <Field
                        id="month"
                        name="month"
                        label={t("Select Month")}
                        component={SingleSelectFieldFF}
                        key="month"
                        options={months != null ? months : []}
                      //onChange={function(){ console.log("ww")}}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </>
          )}
        ></Form>
        {
        surveyFormData != null &&
    surveyFormData.data &&
    programRules != null &&
    programRulesVariables != null &&
    sessionUserBoValue != null &&
    surveyDataSet != null ? (
        <Form
          onSubmit={(values) => submit(values, null, 2)}
          initialValues={initialSurveyValue}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="stock-management fullWidth pl-pr-20" onSubmit={handleSubmit}>
             
             <div
                    className="innertabdivreg surveyformoptionsholder"
                    style={{ "margin-top": "20px" }}
                  >
                    <Grid
                      container
                      spacing={3}
                      className="sureyform_bottomfieldholder"
                    >
              {surveyFormData.data.dataSetElements.map(
                        (fieldsObject) => {
                          let requiredFields =
                            surveyFormData.data &&
                            surveyFormData.data.compulsoryDataElementOperands
                              ? _.find(
                                  surveyFormData.data
                                    .compulsoryDataElementOperands,
                                  { id: fieldsObject.dataElement.id }
                                )
                              : null;
                          if (requiredFields) {
                            fieldsObject.compulsory = true;
                          }
                          if(fieldsObject.dataElement && fieldsObject.dataElement.optionSet && fieldsObject.dataElement.optionSet.options){
                              let radioAttributeValue = _.find(fieldsObject.dataElement.attributeValues,{attribute:{name:"HORIZONTAL_RADIOBUTTONS"} , value:"true"})
                              if(radioAttributeValue){
                                fieldsObject["renderOptionsAsRadio"] = true
                              }
                          }
                          console.log("fieldsObject ",fieldsObject);
                          return renderField(
                            fieldsObject,
                            values != null ? values : {},
                            surveyFormData.data
                          );
                        }
                      )}
              </Grid>
              <br/>      
              <div className="buttons customregistrationtabs">
                <button
                  className="regformsubmitbtn"
                  type="submit"
                // disabled={submitting || pristine}
                >
                  {t("Submit")}
                </button>
              </div>
              </div>
            </form>
          )}
        />)
        :<></>
        }
      </section>
    </>
  );
};

export default DatasetManagement;
